
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

// import { ModelBase, PlayerObject } from '../../../../models';
// import { Feat } from '../../models';
// import DandDAPI from '../../utilities/system_api';

// const api = DandDAPI.getInstance();

export default function FeatIndex() {
  return (
    <FSIndex
      data_type="feat"
      // save_all
      quick_fields={["feat_tier","ability_scores","tags"]}
      // extra_filter={(obj: ModelBase | PlayerObject) => {
      //   if (obj instanceof Feat) {
      //     const variants = obj.variant_group.filter(o => o.source_book_ids.includes("6675b302a4476741138fa22b"));
      //     if (variants.length === 0) {
      //       if (obj.source_book_ids.length === 1 && obj.source_books[0].third_party) {

      //       } else {
      //         return true;
      //       }
      //     }
      //   }
      //   return false;
      // }}
    />
  );
}
